import React from 'react';

export const Header: React.FC = () => {
  const handleLogoError = () => {
    console.error('DiabetesDAO logo failed to load');
  };

  return (
    <header className="w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-3 flex items-center">
        <a 
          href="https://www.diabetesdao.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex-shrink-0"
        >
          <img 
            src="/lovable-uploads/ecfcb8b7-e979-4dc1-801d-905f4f44b354.png" 
            alt="DiabetesDAO"
            className="h-7 md:h-10 w-auto"
            onError={handleLogoError}
          />
        </a>
      </div>
    </header>
  );
};